import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface FunnelStage {
  label: string;
  percentage: number;
  icon: BoxIcon;
  color?: string;
}
interface AnimatedFunnelProps {
  stages: FunnelStage[];
  className?: string;
}
export function AnimatedFunnel({
  stages,
  className = ''
}: AnimatedFunnelProps) {
  return <div className={`flex flex-col items-center w-full max-w-3xl mx-auto ${className}`} data-id="element-244">
      {stages.map((stage, i) => {
      const width = 100 - i * 15; // Decrease width for funnel shape
      return <div key={i} className="relative w-full flex justify-center mb-2" style={{
        zIndex: stages.length - i
      }} data-id="element-245">
            <motion.div className="relative h-20 bg-[#0a4d4d] border border-white/10 rounded-lg overflow-hidden flex items-center justify-between px-8" style={{
          width: `${width}%`
        }} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.15
        }} data-id="element-246">
              {/* Fill animation background */}
              <motion.div className="absolute inset-0 bg-[#4fd1c5]/10" initial={{
            scaleX: 0
          }} animate={{
            scaleX: 1
          }} transition={{
            duration: 1,
            delay: i * 0.2 + 0.5,
            ease: 'easeOut'
          }} style={{
            originX: 0
          }} data-id="element-247" />

              <div className="flex items-center gap-4 relative z-10" data-id="element-248">
                <div className="p-2 rounded-full bg-[#4fd1c5]/20 text-[#4fd1c5]" data-id="element-249">
                  <stage.icon size={24} data-id="element-250" />
                </div>
                <span className="text-xl font-bold text-white" data-id="element-251">
                  {stage.label}
                </span>
              </div>

              <div className="relative z-10" data-id="element-252">
                <span className="text-2xl font-bold text-[#ffd700]" data-id="element-253">
                  {stage.percentage}%
                </span>
              </div>
            </motion.div>
          </div>;
    })}
    </div>;
}